<template>
    <div>
        <div class="content">
            <ul class="listWrap">
                <li v-for="(item,i) in totalPage[currentPage]" :key="i" class="clearfix">
                    <div class="left fl" v-html="item.zstp"></div>
                    <div class="right clearfix" style="display:block;" @click="goto(item.id)">
                        <div class="date fr">发布时间: &nbsp {{ item.date }}</div>
                        <div class="text fl" style="color: #161616">{{ item.title }}</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="pageBox clearfix">
            <el-pagination 
                @current-change="handleCurrentChange"
                background
                layout="prev, pager, next"
                :total="zpvalSize"
                class="fr">
            </el-pagination>
            <div class="num fr">共 {{ zpvalSize }} 条 </div>

        </div>
        
    </div>
</template>

<script>
export default {
    props:['zpval','router'],
    data() {
        return {
            pageSize: 10,//每页显示数量
            totalPage: [],
            pageNum: 1,//当前页面
            dataShow: "",
            currentPage: 0,//默认显示第一页
            zpvalSize: 10
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = `${val}` -1
        },
        goto(val,router) {
            this.$router.push({name:this.$props.router,query: {id:val}})
        }
    },
    watch: {
        zpval(newVal){
            this.zpvalSize = Number(newVal.length)
            this.pageNum = Math.ceil(newVal.length / this.pageSize) || 1
            for(let i =0; i< this.pageNum; i++) {
                this.totalPage[i] = newVal.slice(this.pageSize * i, this.pageSize * (i + 1))
            };
            this.totalPage.push("");
            this.totalPage.pop("")
        },
        deep: true,
        immediate: true
    },
    mounted() {
    }

}
</script>

<style scoped>
    .listWrap li{
        padding: 33px 40px 33px 0;
        font-size: 16px;
        color: #878787;
        border-bottom: 1px dashed #878787;
    }
    .listWrap .right{
        margin-left: 23px;
        cursor: pointer;
    }
    .listWrap li .date,.listWrap li .text{
        margin-top: 25px;
    }
    .listWrap li .title{
        color: #161616;
    }
    .pageBox{
        padding: 30px 0 75px;
    }
    .num{
        height: 29px;
        line-height: 29px;
        border: 1px solid #e3e1e1;
        margin-top: 2px;
        padding: 0 14px;
        color: #878787;
    }
    .text{
        position: relative;
        text-indent: 45px;
    }
    .text::before{
        border: 1px solid #161616;
        width: 10px;
        height: 10px;
        content: "";
        display: block;
        position: absolute;
        border-left: none;
        border-bottom: none;
        transform: rotate(45deg);
        top: 50%;
        margin-top: -5px;
    }
</style>

<style>
    .pageBox .el-pagination .btn-next .el-icon,.pageBox .el-pagination .btn-prev .el-icon{
        font-weight: 500;
    }
    .pageBox .el-pager li{
        font-size: 16px;
    }
    .pageBox .el-icon-arrow-left::before{
        content: "上一页";
        font-size:16px;
    }
    .pageBox .el-icon-arrow-left,.pageBox .el-icon-arrow-right{
        padding: 0px 14px;
    }
    .pageBox .el-icon-arrow-right:before{
        content: "下一页";
        font-size:16px;
    }
    .pageBox .el-pagination.is-background .el-pager li:not(.disabled).active{
        background: #5bb62d;
    }
    .pageBox .el-pager li{
        padding: 4px 14px;
        line-height: inherit;
        height: auto;
        font-weight: 500;
        color: #878787;
    }
    .pageBox .el-pagination.is-background .el-pager li:not(.disabled):hover{
        color: inherit;
    }
    .pageBox .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
        color: #fff;
    }
    .pageBox .el-pagination.is-background .btn-next,.pageBox .el-pagination.is-background .btn-prev,.pageBox .el-pagination.is-background .el-pager li{
        background: #fff;
        border: 1px solid #e5e3e3;
    }
    .pageBox .el-pagination button{
        height: 31px;
    }
</style>